import { RSAA } from 'redux-api-middleware';

import {
  CreateChapterFormDataProps,
  EditChapterFormDataProps,
} from '../../components/clipGeneratorV2/chapters/chapter.types';
import { toFormData } from '../../helpers/requestHelper';

const BASE_ROUTE = `/after-effects/chapters`;

const GET_AFTER_EFFECTS_CHAPTER_REQUEST = 'GET_CHAPTER_REQUEST';
const GET_AFTER_EFFECTS_CHAPTER_SUCCESS = 'GET_CHAPTER_SUCCESS';
const GET_AFTER_EFFECTS_CHAPTER_FAILURE = 'GET_CHAPTER_FAILURE';

export const getAfterEffectsChapters = () => ({
  [RSAA]: {
    types: [GET_AFTER_EFFECTS_CHAPTER_REQUEST, GET_AFTER_EFFECTS_CHAPTER_SUCCESS, GET_AFTER_EFFECTS_CHAPTER_FAILURE],
    endpoint: `${BASE_ROUTE}`,
    method: 'GET',
  },
});

const POST_AFTER_EFFECTS_CHAPTER_REQUEST = 'POST_CHAPTER_REQUEST';
const POST_AFTER_EFFECTS_CHAPTER_SUCCESS = 'POST_CHAPTER_SUCCESS';
const POST_AFTER_EFFECTS_CHAPTER_FAILURE = 'POST_CHAPTER_FAILURE';

export const createAfterEffectsChapter = (body: CreateChapterFormDataProps) => ({
  [RSAA]: {
    types: [POST_AFTER_EFFECTS_CHAPTER_REQUEST, POST_AFTER_EFFECTS_CHAPTER_SUCCESS, POST_AFTER_EFFECTS_CHAPTER_FAILURE],
    endpoint: `${BASE_ROUTE}`,
    method: 'POST',
    body: toFormData(body),
  },
});

const DELETE_AFTER_EFFECTS_CHAPTER_REQUEST = 'DELETE_CHAPTER_REQUEST';
const DELETE_AFTER_EFFECTS_CHAPTER_SUCCESS = 'DELETE_CHAPTER_SUCCESS';
const DELETE_AFTER_EFFECTS_CHAPTER_FAILURE = 'DELETE_CHAPTER_FAILURE';

export const deleteAfterEffectsChapter = (chapterId: string) => ({
  [RSAA]: {
    types: [
      DELETE_AFTER_EFFECTS_CHAPTER_REQUEST,
      DELETE_AFTER_EFFECTS_CHAPTER_SUCCESS,
      DELETE_AFTER_EFFECTS_CHAPTER_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/${chapterId}`,
    method: 'DELETE',
  },
});

const EDIT_AFTER_EFFECTS_CHAPTER_REQUEST = 'EDIT_CHAPTER_REQUEST';
const EDIT_AFTER_EFFECTS_CHAPTER_SUCCESS = 'EDIT_CHAPTER_SUCCESS';
const EDIT_AFTER_EFFECTS_CHAPTER_FAILURE = 'EDIT_CHAPTER_FAILURE';

export const editAfterEffectsChapter = (chapterId: string, body: EditChapterFormDataProps) => ({
  [RSAA]: {
    types: [EDIT_AFTER_EFFECTS_CHAPTER_REQUEST, EDIT_AFTER_EFFECTS_CHAPTER_SUCCESS, EDIT_AFTER_EFFECTS_CHAPTER_FAILURE],
    endpoint: `${BASE_ROUTE}/${chapterId}`,
    method: 'PATCH',
    body: toFormData(body),
  },
});
